module.exports = __webpack_public_path__ + "static/media/radio_blue.1950e595.svg";